import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { snakeCase } from 'lodash';
import styles from './splitview.scss';

const BASE_KEY = 'components.split_view.review';

export default function SplitViewTagActionDropdownItem({
    onClick,
    getMessage,
    itemKey,
}) {
    const itemText = getMessage(`${BASE_KEY}.${snakeCase(itemKey)}`);

    return (
        <span
            role="presentation"
            className={styles['dropdown-item-normal']}
            onClick={onClick}
        >
            <span className={styles[`item-${itemKey}`]} title={itemText}>
                {itemText}
            </span>
        </span>
    );
}

SplitViewTagActionDropdownItem.propTypes = {
    onClick: PropTypes.func.isRequired,
    getMessage: PropTypes.func.isRequired,
    itemKey: PropTypes.string.isRequired,
};

SplitViewTagActionDropdownItem.displayName = displayName('SplitView/SplitViewTagActionDropdownItem');
